import { registerComponent as x } from "@aileron/icon";
import { unsafeCSS as v, LitElement as y } from "lit";
import { html as m, unsafeStatic as E } from "lit/static-html.js";
import { query as M, property as s } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
import { ifDefined as p } from "lit/directives/if-defined.js";
const _ = (l) => {
  class t extends l {
    constructor(...a) {
      super(...a), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (u) => u.href === this.fontLink
      ) === -1) {
        const u = document.createElement("link");
        u.href = this.fontLink, u.rel = "stylesheet", document.head.appendChild(u);
      }
    }
  }
  return t;
}, D = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.mx-16{margin-left:4rem;margin-right:4rem}.mx-4{margin-left:1rem;margin-right:1rem}.my-0{margin-top:0;margin-bottom:0}.my-2{margin-top:.5rem;margin-bottom:.5rem}.inline{display:inline}.inline-flex{display:inline-flex}.hidden{display:none}.h-12{height:3rem}.max-h-\\[48px\\]{max-height:48px}.min-h-\\[48px\\]{min-height:48px}.w-full{width:100%}.min-w-\\[48px\\]{min-width:48px}.max-w-\\[48px\\]{max-width:48px}.cursor-pointer{cursor:pointer}.overflow-hidden{overflow:hidden}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-neutral-070{border-color:#637e9c}.border-neutral-090{border-color:#b4c1cf}.border-red-070{border-color:#e33b4e}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-130{background-color:#f9fafb}.bg-transparent{background-color:transparent}.p-0{padding:0}.text-center{text-align:center}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.text-xs{font-size:.75rem}.leading-4{line-height:1rem}.leading-6{line-height:1.5rem}.text-blue-060{color:#0860c4}.text-neutral-000{color:#101419}.text-neutral-090{color:#b4c1cf}.text-red-060{color:#cd1d32}.placeholder-neutral-060::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(80 101 124 / var(--tw-placeholder-opacity, 1))}.placeholder-neutral-060::placeholder{--tw-placeholder-opacity: 1;color:rgb(80 101 124 / var(--tw-placeholder-opacity, 1))}.shadow{--tw-shadow: 0px 1px 18px 0px rgba(0, 0, 0, .12), 0px 6px 10px 0px rgba(0, 0, 0, .14), 0px 3px 5px -1px rgba(0, 0, 0, .2);--tw-shadow-colored: 0px 1px 18px 0px var(--tw-shadow-color), 0px 6px 10px 0px var(--tw-shadow-color), 0px 3px 5px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline-0{outline-width:0px}.font-normal{font-weight:400;font-variation-settings:"wght" 400}[hidden]{display:none!important}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:border-blue-060:hover{border-color:#0860c4}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.focus\\:border-blue-060:focus{border-color:#0860c4}.focus\\:bg-neutral-130:focus{background-color:#f9fafb}', k = v(D), h = "aileron-color-scheme", g = "aileron-color-scheme-change", I = (l) => {
  const e = class e extends l {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (r) => {
        r.detail ? this.setAttribute(h, r.detail) : this.removeAttribute(h);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        g,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const r = document.documentElement.getAttribute(
        h
      );
      r && this.setAttribute(h, r);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        g,
        this.handleSchemeSwitch
      );
    }
  };
  e.styles = [
    k,
    l.styles ?? []
  ];
  let t = e;
  return t;
}, f = I(_(y)), C = (l) => {
  class t extends l {
    getValidityMessage(a) {
      return {
        "": "",
        required: this.requiredValidityMessage
      }[a];
    }
    testValidity() {
      const { required: a, value: r } = this;
      return a && !r ? "required" : "";
    }
    checkValidity() {
      const a = this.testValidity();
      return a !== "" ? (this.dispatchEvent(
        new CustomEvent("invalid", {
          bubbles: !1,
          cancelable: !0,
          composed: !1
        })
      ) && (this.invalid = !0, this.validityMessage = this.getValidityMessage(a)), !1) : (this.invalid = !1, this.validityMessage = "", !0);
    }
    setCustomValidity(a) {
      this.invalid = !!a, this.validityMessage = a;
    }
  }
  return t;
}, U = ":host{display:flex;flex-direction:column;outline:none;width:100%}:host(.focus-visible),:host(:focus-within){outline:0}:host([disabled]){pointer-events:none}.adc-number-input__input::-webkit-outer-spin-button,.adc-number-input__input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
var X = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, o = (l, t, e, a) => {
  for (var r = a > 1 ? void 0 : a ? $(t, e) : t, d = l.length - 1, c; d >= 0; d--)
    (c = l[d]) && (r = (a ? c(t, e, r) : c(r)) || r);
  return a && r && X(t, e, r), r;
};
const i = {
  EXCEEDED_MAXIMUM: "exceeded_maximum",
  EXCEEDED_MINIMUM: "exceeded_minimum"
}, w = class w extends C(f) {
  constructor(t) {
    super(), this.autocomplete = "", this.name = "", this.pattern = "^[0-9]*$", this.placeholder = "", this.autofocus = !1, this.disabled = !1, this.required = !1, this.invalid = !1, this._value = "", this._min = "", this._max = "", this._step = "1", this.incrementButtonAssistiveText = "increase number input", this.decrementButtonAssistiveText = "decrease number input", this.requiredValidityMessage = "Please fill out this field", this.validityMessage = "", this.validityMessageMax = "", this.validityMessageMin = "", this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-number-input"), x(
      this.customElementString ? this.customElementString + "-number-input" : "adc-number-input"
    );
  }
  /**
   * Handles `input` event on the `<input>` in the shadow DOM.
   */
  _handleInput({ target: t }) {
    this.value = t.value;
  }
  /**
   * When not disabled, append name and value to formData event object.
   */
  handleFormdata(t) {
    const { formData: e } = t, { disabled: a, name: r, value: d } = this;
    !a && r && e.append(r, d);
  }
  /**
   * Handles `click` event on the up button in the shadow DOM.
   */
  _handleUserInitiatedStepUp() {
    const { _input: t } = this;
    this.stepUp(), this.dispatchEvent(
      new CustomEvent(this.constructor.eventInput, {
        bubbles: !0,
        composed: !0,
        cancelable: !1,
        detail: {
          value: t.value
        }
      })
    );
  }
  /**
   * Handles `click` event on the down button in the shadow DOM.
   */
  _handleUserInitiatedStepDown() {
    const { _input: t } = this;
    this.stepDown(), this.dispatchEvent(
      new CustomEvent(this.constructor.eventInput, {
        bubbles: !0,
        composed: !0,
        cancelable: !1,
        detail: {
          value: t.value
        }
      })
    );
  }
  _testValidity() {
    var t, e;
    return ((t = this._input) == null ? void 0 : t.valueAsNumber) > parseFloat(this.max) ? i.EXCEEDED_MAXIMUM : ((e = this._input) == null ? void 0 : e.valueAsNumber) < parseFloat(this.min) ? i.EXCEEDED_MINIMUM : super.testValidity();
  }
  get min() {
    return this._min.toString();
  }
  set min(t) {
    const e = this.min;
    this._min = t, this.requestUpdate("min", e);
  }
  get step() {
    return this._step.toString();
  }
  set step(t) {
    const e = this.step;
    this._step = t, this.requestUpdate("step", e);
  }
  get max() {
    return this._max.toString();
  }
  set max(t) {
    const e = this.max;
    this._max = t, this.requestUpdate("max", e);
  }
  /**
   * Handles incrementing the value in the input
   */
  stepUp() {
    this._input.stepUp();
    const t = this._value;
    this._value = this.value, this.requestUpdate("value", t);
  }
  /**
   * Handles decrementing the value in the input
   */
  stepDown() {
    this._input.stepDown();
    const t = this._value;
    this._value = this.value, this.requestUpdate("value", t);
  }
  get value() {
    return this._input ? this._input.value : this._value;
  }
  set value(t) {
    const e = this._value;
    this._value = t, this.requestUpdate("value", e), this._input && (this._input.value = t);
  }
  renderIncrementButton() {
    const { _handleUserInitiatedStepUp: t } = this, e = this._testValidity();
    return m`
      <button
        class="adc-number-input__control rounded border border-solid border-blue-060 text-blue-060 min-w-[48px] max-w-[48px] min-h-[48px] max-h-[48px]${b(
      {
        "border-neutral-090": this.disabled || e === i.EXCEEDED_MAXIMUM,
        "text-neutral-090": this.disabled || e === i.EXCEEDED_MAXIMUM,
        "bg-transparent": e === i.EXCEEDED_MAXIMUM,
        "hover:bg-neutral-130": e !== i.EXCEEDED_MAXIMUM,
        "hover:cursor-pointer": e !== i.EXCEEDED_MAXIMUM,
        "focus:bg-neutral-130": e !== i.EXCEEDED_MAXIMUM
      }
    )}"
        aria-label="${this.incrementButtonAssistiveText}"
        aria-live="polite"
        aria-atomic="true"
        type="button"
        ?disabled=${this.disabled}
        @click=${t}
        id="incrementButton"
      >
        <${this.createTagName(
      "-number-input-icon"
    )} icon="action:plus"></${this.createTagName("-number-input-icon")}>
      </button>
    `;
  }
  renderDecrementButton() {
    const { _handleUserInitiatedStepDown: t } = this, e = this._testValidity();
    return m`
      <button
        class="adc-number-input__control rounded border border-solid border-blue-060 text-blue-060 min-w-[48px] max-w-[48px] min-h-[48px] max-h-[48px]  ${b(
      {
        "border-neutral-090": this.disabled || e === i.EXCEEDED_MINIMUM,
        "text-neutral-090": this.disabled || e === i.EXCEEDED_MINIMUM,
        "bg-transparent": e === i.EXCEEDED_MINIMUM,
        "hover:bg-neutral-130": e !== i.EXCEEDED_MINIMUM,
        "hover:cursor-pointer": e !== i.EXCEEDED_MINIMUM,
        "focus:bg-neutral-130": e !== i.EXCEEDED_MINIMUM
      }
    )}"
        aria-label="${this.decrementButtonAssistiveText}"
        aria-live="polite"
        aria-atomic="true"
        type="button"
        ?disabled=${this.disabled}
        @click=${t}
        id="decrementButton"
      >
        <${this.createTagName("-number-input-icon")}
         icon="action:subtract"></${this.createTagName("-number-input-icon")}>
      </button>
    `;
  }
  createTagName(t) {
    return E(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    const { _handleInput: t } = this, e = this._testValidity(), a = () => this.invalid && e !== i.EXCEEDED_MAXIMUM && e !== i.EXCEEDED_MINIMUM, r = () => this.required, d = this.invalid || this.required || e === i.EXCEEDED_MINIMUM || e === i.EXCEEDED_MAXIMUM, c = {
      "adc-number-input__input": !0,
      "border-red-070": d,
      "hover:border-blue-060": this.invalid || this.required,
      "bg-neutral-090": this.disabled,
      "border-neutral-090": this.disabled,
      "text-neutral-090": this.disabled,
      "border-neutral-070": !d,
      "focus:border-blue-060": e !== i.EXCEEDED_MINIMUM && e !== i.EXCEEDED_MAXIMUM
    };
    return m`
      <div class="inline-flex" ?data-invalid="${this.invalid}">
        ${this.renderDecrementButton()}
        <input
          autocomplete="${this.autocomplete}"
          class="adc-number-input__input font-sans text-base font-normal   leading-6 rounded border border-solid text-neutral-000 h-12 w-full p-0 outline-0 outline-none text-center my-0 mx-4 placeholder-neutral-060 ${b(
      c
    )}"
          ?data-invalid="${this.invalid}"
          ?disabled="${this.disabled}"
          id="input"
          name="${p(this.name)}"
          pattern="[0-9]"
          placeholder="${p(this.placeholder)}"
          ?required="${this.required}"
          type="number"
          .value="${this._value}"
          @input="${t}"
          min="${p(this.min)}"
          max="${p(this.max)}"
          step="${p(this.step)}"
        />
        ${this.renderIncrementButton()}
      </div>
      <div
        class="font-sans font-normal text-xs   leading-4 text-red-060 overflow-hidden my-2 mx-16"
      >
        <div class="validity" ?hidden="${!a()}">
          <slot name="validity-message"> ${this.validityMessage} </slot>
        </div>
        <div class="required" ?hidden="${!r()}">
          <slot name="required-validity-message">
            ${this.requiredValidityMessage}
          </slot>
        </div>
        <div
          class="message-max"
          ?hidden="${e !== i.EXCEEDED_MAXIMUM}"
        >
          <slot name="validity-message-max"> ${this.validityMessageMax} </slot>
        </div>
        <div
          class="message-min"
          ?hidden="${e !== i.EXCEEDED_MINIMUM}"
        >
          <slot name="validity-message-min"> ${this.validityMessageMin} </slot>
        </div>
      </div>
    `;
  }
  _getValidityMessage(t) {
    return Object.values(i).includes(t) ? {
      [i.EXCEEDED_MAXIMUM]: this.validityMessageMax,
      [i.EXCEEDED_MINIMUM]: this.validityMessageMin
    }[t] : super.getValidityMessage(t);
  }
  /**
   * The name of the custom event fired after the value is changed upon a user
   * gesture.
   */
  static get eventInput() {
    return "adc-number-input-input-value";
  }
};
w.styles = [f.styles || [], v(U)];
let n = w;
o([
  M("input")
], n.prototype, "_input", 2);
o([
  s({ reflect: !0 })
], n.prototype, "min", 1);
o([
  s({ reflect: !0 })
], n.prototype, "step", 1);
o([
  s({ reflect: !0 })
], n.prototype, "max", 1);
o([
  s()
], n.prototype, "autocomplete", 2);
o([
  s()
], n.prototype, "name", 2);
o([
  s()
], n.prototype, "pattern", 2);
o([
  s({ reflect: !0 })
], n.prototype, "placeholder", 2);
o([
  s({ type: Boolean })
], n.prototype, "autofocus", 2);
o([
  s({ type: Boolean, reflect: !0 })
], n.prototype, "disabled", 2);
o([
  s({ type: Boolean, reflect: !0 })
], n.prototype, "required", 2);
o([
  s({ type: Boolean, reflect: !0 })
], n.prototype, "invalid", 2);
o([
  s({ attribute: "increment-button-assistive-text" })
], n.prototype, "incrementButtonAssistiveText", 2);
o([
  s({ attribute: "decrement-button-assistive-text" })
], n.prototype, "decrementButtonAssistiveText", 2);
o([
  s({ attribute: "required-validity-message" })
], n.prototype, "requiredValidityMessage", 2);
o([
  s({ attribute: "validity-message" })
], n.prototype, "validityMessage", 2);
o([
  s({ attribute: "validity-message-max" })
], n.prototype, "validityMessageMax", 2);
o([
  s({ attribute: "validity-message-min" })
], n.prototype, "validityMessageMin", 2);
o([
  s({ reflect: !0 })
], n.prototype, "value", 1);
try {
  customElements.define("adc-number-input", n), console.warn(
    "@aileron/number-input is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/number-input"
  );
} catch {
}
function A(l) {
  try {
    customElements.define(
      `${l}-number-input`,
      class extends n {
        constructor() {
          super(l);
        }
      }
    );
  } catch {
  }
}
function T(l) {
  try {
    A(l);
  } catch {
  }
}
export {
  i as NUMBER_INPUT_VALIDATION_STATUS,
  n as NumberInput,
  T as registerComponent,
  A as registerNumberInput
};
